import React from 'react';
import { Icon as BlueIcon, IconName } from '@blueprintjs/core';
import { Label, Item } from './MenuContent.styles';

export interface MenuItemProps {
  onClick: VoidFunction;
  label: string;
  icon?: IconName;
}
export function MenuItem({ onClick, label, icon }: MenuItemProps) {
  return (
    <Item onClick={onClick} className="new-icon">
      <BlueIcon icon={icon} color="var(--beam-color-neutral-n600)" />
      <Label>{label}</Label>
    </Item>
  );
}
